$(function() {
  $('model-viewer').fadeOut(0);
  $('.model-area model-viewer:nth-of-type(1)').fadeIn();

  $('sticky-header').hover(function() {
    $(this).addClass('reveal');
  }, function() {    
    $(this).removeClass('reveal');
  });

  $('.model-blocker').click(function() {
    $(this).fadeOut(250);
  });

  $('.product-form__input--pill input').click(function(e) {
    // e.preventDefault();
    $('.model-blocker').fadeIn(250);
    var clickID = $(this).attr('id');
    $(this).addClass('selected');
    switch ($(this).val()) {
      case "MTB: 26 inch":
        $('model-viewer').fadeOut(0);
        var is = $('variant-selects .product-form__input:nth-of-type(3) input:checked');
        
        switch ($(is).val()) {
          case "Top tube mounted":
            $('.model-area model-viewer:nth-of-type(1)').fadeIn();
            break;
          case "Down tube mounted":
            $('.model-area model-viewer:nth-of-type(5)').fadeIn();
            break;
          default:
            break;
        }
        
        break;
      case "MTB: 27.5 inch":
        $('model-viewer').fadeOut(0);
        var is = $('variant-selects .product-form__input:nth-of-type(3) input:checked');
        
        switch ($(is).val()) {
          case "Top tube mounted":
            $('.model-area model-viewer:nth-of-type(2)').fadeIn();
            break;
          case "Down tube mounted":
            $('.model-area model-viewer:nth-of-type(6)').fadeIn();
            break;
          default:
            break;
        }
        
        break;
      case "MTB: 29 inch":
        $('model-viewer').fadeOut(0);
        var is = $('variant-selects .product-form__input:nth-of-type(3) input:checked');
        
        switch ($(is).val()) {
          case "Top tube mounted":
            $('.model-area model-viewer:nth-of-type(3)').fadeIn();
            break;
          case "Down tube mounted":
            $('.model-area model-viewer:nth-of-type(7)').fadeIn();
            break;
          default:
            break;
        }
        
        break;
      case "Hybrid: 700c":
        $('model-viewer').fadeOut(0);
        var is = $('variant-selects .product-form__input:nth-of-type(3) input:checked');
        
        switch ($(is).val()) {
          case "Top tube mounted":
            $('.model-area model-viewer:nth-of-type(4)').fadeIn();
            break;
          case "Down tube mounted":
            $('.model-area model-viewer:nth-of-type(8)').fadeIn();
            break;
          default:
            break;
        }
        
        break;
      case "Top tube mounted":
        // console.log($('variant-selects .product-form__input:nth-of-type(2) input:checked'));
        var ws = $('variant-selects .product-form__input:nth-of-type(2) input:checked');
        
        switch ($(ws).val()) {
          case "MTB: 26 inch":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(1)').fadeIn();
            break;
          case "MTB: 27.5 inch":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(2)').fadeIn();
            break;
          case "MTB: 29 inch":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(3)').fadeIn();
            break;
          case "Hybrid: 700c":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(4)').fadeIn();
            break;
        }
        
        break;
      case "Down tube mounted":
        var ws = $('variant-selects .product-form__input:nth-of-type(2) input:checked');
        console.log($(ws).val());
        
        switch ($(ws).val()) {
          case "MTB: 26 inch":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(5)').fadeIn();
            break;
          case "MTB: 27.5 inch":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(6)').fadeIn();
            break;
          case "MTB: 29 inch":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(7)').fadeIn();
            break;
          case "Hybrid: 700c":
            $('model-viewer').fadeOut(0);
            $('.model-area model-viewer:nth-of-type(8)').fadeIn();
            break;
        }
        break;
      default:
        break;
    }
    // $(this).parents('fieldset').find('label').each(function() {
    //   if ($(this).attr('for') == clickID) {
    //     console.log($(this).text());
        
    //   }
    // });
    // $(this).addClass('selected');

    
  });

  if (window.location.href == "https://arkeglobal.com/") {
    $('body').addClass('home');
  }


  
});